"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Page = _interopRequireDefault(require("@rsuite/icon-font/lib/file/Page"));

// Generated by script, don't edit it please.
var Page = (0, _createSvgIcon["default"])({
  as: _Page["default"],
  ariaLabel: 'page',
  category: 'file',
  displayName: 'Page'
});
var _default = Page;
exports["default"] = _default;
module.exports = exports.default;